import React, { useState } from "react";
import { Button, Spin, message, Alert } from "antd";
import { updateException } from "../api";
import { ExceptionStatus } from "../ExceptionDrawer";
import Hide from "../../components/Hide";

const MissingLgaNameComponent = ({ exception, onClose, onResolved }) => {
    const [loading, setLoading] = useState(false);

    const handleManualResolve = async () => {
        setLoading(true);
        if (exception.status === 'pending') {
            try {
                await updateException(exception.id);
                message.success('Exception marked as resolved');
                try { 
                    if (typeof onResolved === 'function') await onResolved(); 
                } catch {}
                onClose();
            } catch (error) {
                message.error('Failed to resolve exception');
            } finally {
                setLoading(false);
            }
        } else {
            console.warn("Exception already resolved.");
            try { 
                if (typeof onResolved === 'function') await onResolved(); 
            } catch {}
            onClose();
        }
    };

    return (
        <div style={{ marginTop: 20 }}>
            <Hide condition={exception.status === ExceptionStatus.RESOLVED}>
                <Spin spinning={loading} tip="Processing...">
                    <Alert
                        message="Missing LGA Name in Onboarding Sheet"
                        description={
                            <div>
                                <p>
                                    This exception indicates that there is a missing LGA (Local Government Area) name 
                                    in the project onboarding Excel sheet. Please follow these steps to resolve:
                                </p>
                                <ol style={{ marginLeft: 20, marginTop: 10 }}>
                                    <li>Open the project onboarding Excel sheet</li>
                                    <li>Locate the row with the missing LGA name</li>
                                    <li>Add the appropriate LGA name in the designated column</li>
                                    <li>Ensure the LGA name is accurate and matches official records</li>
                                    <li>Verify the LGA name spelling and format</li>
                                    <li>Save and update the Excel sheet</li>
                                </ol>
                                <p style={{ marginTop: 15, fontWeight: 'bold' }}>
                                    Once you've added the missing LGA name to the onboarding Excel sheet, 
                                    you can manually mark this exception as resolved.
                                </p>
                            </div>
                        }
                        type="warning"
                        showIcon
                        style={{ marginBottom: 20 }}
                    />
                    
                    <div style={{ textAlign: 'center' }}>
                        <Button
                            type="primary"
                            size="large"
                            onClick={handleManualResolve}
                            disabled={loading}
                            loading={loading}
                            style={{ minWidth: 200 }}
                        >
                            Mark Exception as Resolved
                        </Button>
                    </div>
                    
                    <div style={{ 
                        marginTop: 20, 
                        padding: 15, 
                        backgroundColor: '#f6f8fa', 
                        borderRadius: 6,
                        border: '1px solid #e1e4e8'
                    }}>
                        <p style={{ margin: 0, fontSize: 12, color: '#586069' }}>
                            <strong>Note:</strong> This button manually resolves the exception. 
                            Only use it after you have confirmed that the missing LGA name 
                            has been properly added to the project onboarding Excel sheet.
                        </p>
                    </div>
                </Spin>
            </Hide>
        </div>
    );
};

export default MissingLgaNameComponent;
